import { useState } from 'react';

import { type FieldPath, LastNameInput, useFormField } from '@american-autonomy/ag-ui';

import WithField from 'components/WithField';

import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FieldValues, Props, RegisterOptions } from './types';

import styles from './styles.module.scss';

const LastNameField = <T extends FieldValues>(props: Props<T>) => {
    const {
        className = '',
        control,
        isDisabled,
        isEditable,
        isRequired,
        name,
        placeholder,
        testId = TEST_ID
    } = props;

    const { LAST_NAME_FIELD_LABEL } = useTranslation();

    const [validationRules, setValidationRules] = useState<RegisterOptions<T, FieldPath<T>>>({});

    const {
        field: { onBlur, onChange, ref, value }
    } = useFormField({
        control,
        name,
        rules: validationRules
    });

    const handleInit = (rules: RegisterOptions) => {
        setValidationRules(rules as RegisterOptions<T, FieldPath<T>>);
    };

    return (
        <WithField
            className={className}
            isRequired={isRequired}
            label={LAST_NAME_FIELD_LABEL}
            testId={testId}>
            <LastNameInput
                className={styles.lastNameInput}
                isDisabled={isDisabled}
                isEditable={isEditable}
                isRequired={isRequired}
                name={name as string}
                onBlur={onBlur}
                onChange={onChange}
                onInit={handleInit}
                placeholder={placeholder}
                ref={ref}
                value={value}
            />
        </WithField>
    );
};

export default LastNameField;
